'use client';

import React, { useEffect, ReactNode } from 'react';

export function detectMobileDevice() {
  if (typeof navigator !== 'undefined') {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/.test(userAgent);
    return isMobile;
  } else {
    return false;
  }
}

interface MobileDeviceCheckerProps {
  mobileContent: ReactNode | null;
  desktopContent: ReactNode;
}

export const MobileDeviceChecker: React.FC<MobileDeviceCheckerProps> = ({ mobileContent, desktopContent }) => {
  const isMobileOrTablet = detectMobileDevice();
  useEffect(() => {
    detectMobileDevice();
  }, []);

  return isMobileOrTablet && mobileContent ? mobileContent : desktopContent;
};
